import React from 'react';
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

import "@abgov/web-components";
import { Helmet } from "react-helmet";
import { AuthProvider } from "react-oidc-context";
import { oidcConfig } from './common/kcConfig.ts';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LookupContextProvider } from './common/contexts/apiContext.tsx';
import { muiGoATheme } from './common/mui-theme.ts';



const queryClient = new QueryClient();
createRoot(document.getElementById('root')!).render(

  <>
    <Helmet>
      <script
        type="module"
        src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"
      ></script>
      <script
        src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"
      ></script>
    </Helmet>
    <AuthProvider {...oidcConfig}>
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ThemeProvider theme={muiGoATheme}>
              <LookupContextProvider >
              <App />
              </LookupContextProvider >
            </ThemeProvider>
          </LocalizationProvider>
        </QueryClientProvider>
      </React.StrictMode>
    </AuthProvider>
  </>
)